import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export function listenToSectionsByCategory(
  categoryId,
  onSuccess,
  onError
) {
  if (!categoryId) {
    onSuccess([]);
    return () => {};
  }

  const sectionsQuery = query(
    collection(db, "sections"),
    where("categoryId", "==", categoryId),
    where("isActive", "==", true),
    orderBy("displayOrder", "asc")
  );

  return onSnapshot(
    sectionsQuery,
    (snapshot) => {
      const sections = snapshot.docs.map((document) => {
        const data = document.data();
        return {
          id: document.id,
          ...data,
          imageUrl: data.websiteImageUrl || data.imageUrl || data.image || "",
        };
      });

      onSuccess(sections);
    },
    onError
  );
}
